class SettlementSearchController {
    constructor($log, $window, toastr, UserDetailsApi, DateRangeService, SettlementServiceApi) {
        this.$onInit = () => {
            // Set default values
            let selectedTester = {
                Id: 0,
                Name: 'Select Tester'
            };
            this.selectedTester = selectedTester;
            let selectedSim = { SimId: 0, SimName: 'Select Sim', Running: false };
            this.selectedSim = selectedSim;
            let dateOptions = {
                formatYear: 'yy',
                startingDay: 1,
                maxDate: new Date()
            };
            this.selectedRange = {
                name: 'Today',
                start: moment(),
                end: moment()
            };
            // TODO : re-enable the caption in an appropriate place or remove.
            this.searchCaption = '';
            let user;
            this.UserDetailsApi.get().then(response => {
                user = response.data;
                this.user = user;
                this.populateTesters(user);
                let isSupport = this.isSupportUser(user);
                this.isSupport = isSupport;
                if (isSupport) {
                    this.resetTester();
                    this.isOpen = false;
                }
                else {
                    this.selectedTester.Id = user.Id;
                    this.selectedTester.Name = user.UserName;
                    this.selectTester(null, this.selectedTester, null);
                    this.isOpen = false;
                }
            });
            this.dateOptions = dateOptions;
            let ranges = this.DateRangeService.ranges;
            this.ranges = ranges;
            let selectedRange = ranges[0];
            this.selectRange(selectedRange);
        };
        this.populateTesters = (user) => {
            this.SettlementServiceApi.settlementTesters(user).then(response => {
                let settlementDto = response.data;
                this.testers = settlementDto.Testers;
                this.maxTraces = settlementDto.MaxTraces;
            });
        };
        this.isSupportUser = (user) => {
            return user.IsSupport || user.IsProjectTester;
        };
        this.resetTester = () => {
            if (this.isSupport) {
                this.selectedTester = { Id: 0, Name: '' };
                this.onTesterChange({ tester: this.selectedTester });
                this.isOpen = true;
            }
        };
        this.selectRange = (range) => {
            this.selectedRange = range;
            let dtFm = range.start;
            this.dtFm = dtFm.toDate();
            this.tmFm = dtFm.startOf('days');
            let dtTo = range.end;
            this.dtTo = dtTo.toDate();
            this.tmTo = dtTo.endOf('days');
            this.formatDateRange(dtFm.toDate(), dtTo.toDate());
        };
        this.selectSim = (sim) => {
            this.selectedSim = sim;
        };
        this.selectTester = ($item, $model, $label) => {
            let tester = $model;
            this.selectedTester = tester;
            this.SettlementServiceApi.sims(tester.Id).then(response => {
                let sims = response.data;
                this.sims = sims;
                this.onTesterChange({ tester: tester });
            });
        };
        this.ok = () => {
            const req = {
                TesterId: this.selectedTester.Id,
                PrimarySimId: this.selectedSim.SimId,
                DateFm: this.dtFm.toISOString(),
                DateTo: this.dtTo.toISOString(),
                CreatingUserId: this.user.Id
            };
            this.settlementSearchRequest = req;
            // TODO : re-enable the caption in an appropriate place or remove.
            this.searchCaption = `Searching...`;
            this.SettlementServiceApi.search(req).then(response => {
                let res = response.data;
                // TODO: Handle DuplicateSearch
                if (res.duplicate) {
                    this.toastr.info(`This search will produce the Settlement file highlighted.`);
                    this.onSearch();
                    this.onDuplicateSearch({ fileId: res.duplicate });
                    // duplicate to disable the process button
                    this.numRecs = 0;
                    this.numTraces = 0;
                    return;
                }
                // TODO : re-enable the caption in an appropriate place or remove.
                this.searchCaption = ``;
                // TODO: Handle case where res.NumTraces > vm.maxTraces
                if (res.NumTraces >= res.SettlementMaxTraces) {
                    this.toastr.info(`Too many trace. please decrease search date range. You got ${res.NumTraces} You are only allowed ${res.SettlementMaxTraces}`);
                    // disable the process button
                    this.numRecs = 0;
                    this.numTraces = 0;
                    return;
                }
                if (res.TestCases === 0) {
                    this.toastr.warning('Search did not find any traces.');
                    return;
                }
                this.toastr.info(`${res.NumTraces} traces for ${res.TestCases} test cases found`);
                // TODO: pass to Process Traces
                this.settlementSearchResponse = res;
                this.numRecs = res.TestCases;
                this.numTraces = res.NumTraces;
            });
        };
        this.disableSimSelection = () => {
            if (this.selectedTester.Id === 0) {
                return true;
            }
            return false;
        };
        // todo: comprehend response
        this.disableOk = () => {
            if (this.selectedTester.Id === 0) {
                this.numRecs = 0;
                this.numTraces = 0;
                return true;
            }
            if (this.selectedSim.SimId === 0) {
                this.numRecs = 0;
                this.numTraces = 0;
                return true;
            }
            return !this.isDateValid;
        };
        this.cancel = () => {
            this.logService.log('Reset Seaarch Criteria');
            this.resetTester();
            this.resetSim();
            this.resetDate();
            // disables the Process button
            this.numRecs = 0;
            this.numTraces = 0;
        };
        this.resetDate = () => {
            this.selectedRange = {
                name: 'Today',
                start: moment(),
                end: moment()
            };
            let ranges = this.DateRangeService.ranges;
            this.ranges = ranges;
            let selectedRange = ranges[0];
            this.selectRange(selectedRange);
        };
        this.resetSim = () => {
            this.selectedSim = { SimId: 0, SimName: 'Select Sim', Running: false };
        };
        this.processTraces = () => {
            let searchRequest = this.settlementSearchRequest;
            let searchResponse = this.settlementSearchResponse;
            let req = {
                SearchRequest: searchRequest,
                SearchResponse: searchResponse
            };
            this.SettlementServiceApi.addRequest(req).then(response => {
                let fileId = response.data;
                this.toastr.info('New request created, ID: ' + fileId);
                this.SettlementServiceApi.processTraces(fileId).then(response => {
                    let result = response.data;
                    if (!result) {
                        this.toastr.error('Request submission failed');
                    }
                    // TODO : re-enable the caption in an appropriate place or remove.
                    this.searchCaption = result
                        ? 'Settlement request submitted'
                        : 'Settlement request submission error';
                });
            });
            // reset the numRecs so we disable the button and make the user search again
            this.numRecs = 0;
            this.numTraces = 0;
        };
        this.formatDateRange = (dtFm, dtTo) => {
            if (dtFm >= dtTo) {
                this.isDateValid = false;
                if (this.showToastr) {
                    this.showToastr = false;
                    this.toastr.error('To date must be after from date', 'Invalid date search', { onHidden: () => this.showToastr = true });
                }
            }
            else {
                this.isDateValid = true;
            }
        };
        this.open1 = () => {
            this.popup1 = true;
        };
        this.open2 = () => {
            this.popup2 = true;
        };
        this.toastr = toastr;
        this.logService = $log;
        this.WindowService = $window;
        this.UserDetailsApi = UserDetailsApi;
        this.DateRangeService = DateRangeService;
        this.SettlementServiceApi = SettlementServiceApi;
        this.numRecs = 0;
        this.numTraces = 0;
        this.showToastr = true;
        this.dateError = '';
        this.isDateValid = true;
    }
}
angular.module('app').component('settlementSearch', {
    bindings: {
        onTesterChange: '&',
        onDuplicateSearch: '&',
        onSearch: '&'
    },
    templateUrl: 'scripts/app/partials/settlement/settlement-search.tpl.html',
    controllerAs: 'vm',
    controller: SettlementSearchController
});
